<template>
  <div class="ma-4 px-4">
    <v-row class="px-3 pt-3">
      <div>
        <span class="text-5xl font-weight-bold accent--text">
          Course :
          {{ course == "all" ? "All Courses" : course.toUpperCase() }}</span
        >
        <v-spacer></v-spacer>
        <span
          class="text-5xl font-weight-bold accent--text"
          v-if="key === 'courseCompletion'"
        >
          Percentage Completion :
          {{ percentageCompletion }}%</span
        >
        <span
          class="text-5xl font-weight-bold accent--text"
          v-if="key === 'timeSpent'"
        >
          Total Time Spent (Mins):
          {{ timeSpentTotal }}</span
        >
        <span
          class="text-5xl font-weight-bold accent--text"
          v-if="key === 'assignmentMark'"
        >
          Total Assessment Score :
          {{ totalAssessmentScore }}</span
        >
      </div>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-select
          v-model="filterWeek"
          :items="weeks"
          label="Week"
          outlined
          dense
          clearable
          hide-details="auto"
        ></v-select>
      </v-col>
    </v-row>

    <v-row class="pt-3">
      <v-col cols="12">
        <v-sheet outlined v-if="key === 'timeSpent'">
          <v-data-table
            :headers="timeSpentHeaders"
            :items="filteredCourseData"
            item-key="name"
            fixed-header
            class="secondary row-height-50"
          >
          </v-data-table>
        </v-sheet>
        <v-sheet outlined v-if="key === 'courseCompletion'">
          <v-data-table
            :headers="coursecompletionHeaders"
            :items="filteredCourseData"
            item-key="name"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.percentage_completion`]="{ value }">
              {{ value != 0 ? value + "%" : value }}
            </template>
          </v-data-table>
        </v-sheet>
        <v-sheet outlined v-if="key === 'assignmentMark'">
          <v-data-table
            :headers="assignmentMarkHeaders"
            :items="filteredCourseData"
            item-key="name"
            fixed-header
            class="secondary row-height-50"
          >
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formDialog from "@/components/course/form.vue";
import {
  coursecompletionHeaders,
  timeSpentHeaders,
  assignmentMarkHeaders,
} from "@/constants/headers";
export default {
  components: {
    formDialog,
  },
  data() {
    return {
      key: "",
      courseCompletionData: [],
      coursecompletionHeaders,
      timeSpentHeaders,
      assignmentMarkHeaders,
      filterWeek: "",
      weeks: [],
      course: "",
    };
  },
  watch: {},
  computed: {
    filteredCourseData() {
      return this.filterWeek
        ? this.courseCompletionData.filter(
            (item) => item.unit === this.filterWeek
          )
        : this.courseCompletionData;
    },
    percentageCompletion() {
      const total = this.filteredCourseData.reduce(
        (acc, el) => acc + (el.percentage_completion || 0),
        0
      );
      return this.filteredCourseData.length
        ? (total / this.filteredCourseData.length).toFixed(2)
        : "0.00";
    },
    timeSpentTotal() {
      return this.filteredCourseData.reduce(
        (sum, item) => sum + (Number(item["time_spent_(mins)"]) || 0),
        0
      );
    },
    totalAssessmentScore() {
      return this.filteredCourseData.reduce(
        (sum, item) => sum + (Number(item.assessment_score) || 0),
        0
      );
    },
  },

  created() {
    const title = this.$route.query.title;
    this.key = this.$route.query.key;
    this.course = this.$route.query.course;
    this.$store.commit("setBreadcrumbs", [
      { text: "Dashboard", to: { name: "Dashboard" } },
      { text: title },
    ]);
    this.initialise();
  },

  methods: {
    initialise() {
      this.fetchCourseCompletion(this.course);
    },
    async fetchCourseCompletion(course) {
      try {
        const res = await this.$axios.get(`/get_dashboard?course=${course}`);
        const records = res.data.data.records;

        this.weeks = [
          ...new Set(records.map((item) => item["Unit"]).filter(Boolean)),
        ];

        this.courseCompletionData = this.keysToSnakeCase(records).sort(
          (a, b) => a.v_lms_id - b.v_lms_id
        );
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response
        );
        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      }
    },

    toSnakeCase(str) {
      return str
        .replace(/\s+/g, "_") // Replace spaces with underscores
        .replace(/[A-Z]/g, (letter) => `${letter.toLowerCase()}`) // Add _ before capital letters
        .replace(/^_+/, "") // Remove leading underscores
        .toLowerCase();
    },

    keysToSnakeCase(obj) {
      if (Array.isArray(obj)) {
        return obj.map(this.keysToSnakeCase);
      } else if (obj !== null && typeof obj === "object") {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [
            this.toSnakeCase(key),
            this.keysToSnakeCase(value),
          ])
        );
      }
      return obj;
    },
  },
};
</script>

<style>
.reset-card-text {
  font-size: medium !important;
  font-weight: normal !important;
  line-height: normal !important;
  letter-spacing: normal !important;
}
</style>
